import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { useIntl } from "../../../../../shared/core/i18n/use-intl";
import { Path } from "../../../../core/routing/path";
import { BluePrimaryButton } from "../../../common/buttons/primary-button";
import { MarkdownText } from "../../../common/forms/markdown-text";
import { StaticAssets } from "../../../styles/custom-assets";
import { theme } from "../../../styles/theme";
import EnrollmentLayout from "../shared/components/enrollment-layout";

export const OnboardingFileSubmittedScreen: React.FC = () => {
  const { push } = useHistory();
  const { formatMessage } = useIntl();

  return (
    <EnrollmentLayout centered>
      <Panel>
        <SuccessLogoImage src={StaticAssets.confirmation} alt="" />
        <Title>{formatMessage("onboardingScreen.successIntroduction")}</Title>
        <Subtitle>{formatMessage("onboardingScreen.successTitle")}</Subtitle>
        <StartButton size="S" onClick={() => push(Path.Root)}>
          {formatMessage("onboardingScreen.successButton")}
        </StartButton>
      </Panel>
    </EnrollmentLayout>
  );
};

/* Centred in the panel with room to breathe, instead of stacked tight against the top. */
const Panel = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 420px;
  margin: 0 auto;
  padding: 48px 0;
  text-align: center;
`;

const SuccessLogoImage = styled.img`
  width: 160px;
  height: 160px;
  margin-bottom: 40px;
  object-fit: contain;
`;

const Title = styled(MarkdownText)`
  ${theme.boldText};
  margin-bottom: 16px;
  font-size: 32px;
  line-height: 42px;
  color: ${theme.colors.blue[800]};
`;

const Subtitle = styled(MarkdownText)`
  margin-bottom: 48px;
  font-size: 16px;
  line-height: 24px;
  color: ${theme.colors.gray[800]};
`;

const StartButton = styled(BluePrimaryButton)``;
